import { useDispatch } from 'react-redux';
import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';
import { LoadingModal } from '../component/modal/modal';
import List from '../component/list/list';
import Layout from './components/Layout';
import dayjs from 'dayjs';
import { formatDateTime, changeNum } from '../common/function';
import './styles/v2.css';

function PaylistV2() {
    let navigate = useNavigate();
    let dispatch = useDispatch();

    useEffect(() => {
    }, []);

    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [maxFirstPage, setMaxFirstPage] = useState(40);
    const [amount, setAmount] = useState([0, 0]);
    const [listData, setListData] = useState([]);
    const [combineData, setCombineData] = useState([]);
    const [reload, setReload] = useState(false);
    const [spinner, setSpinner] = useState(false);

    // 날짜 상태
    const [preDate, setPreDate] = useState(dayjs().startOf('month').format('YYYY/MM/DD'));
    const [nextDate, setNextDate] = useState(dayjs().endOf('month').format('YYYY/MM/DD'));

    // 컬럼별 필터 상태
    const [columnFilters, setColumnFilters] = useState({
        trxDate: "",
        amt: "",
        cardNum: ""
    });

    // 활성화된 빠른 필터 추적
    const [activeQuickFilter, setActiveQuickFilter] = useState(null);

    const [listState, setListState] = useState(false);
    const observerRef = useRef(null);

    useEffect(() => {
        // 디버깅 정보 저장
        localStorage.setItem('v2_paylist_debug', JSON.stringify({
            step: 'useEffect 시작',
            timestamp: new Date().toISOString(),
            hasUserData: !!localStorage.getItem("userId")
        }));

        // 인증 체크
        const userData = localStorage.getItem("userId");
        if (!userData) {
            localStorage.setItem('v2_paylist_debug', JSON.stringify({
                step: '인증 실패 - 리다이렉트',
                timestamp: new Date().toISOString()
            }));
            navigate('/', { replace: true });
            return;
        }

        localStorage.setItem('v2_paylist_debug', JSON.stringify({
            step: '컴포넌트 마운트 완료',
            timestamp: new Date().toISOString()
        }));

        dispatch(change_Current_Location("거래조회"));
        dispatch(changeHeaderTitle({
            mainTitle: "거래조회 (V2)",
            subTitle: ""
        }));

        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, [dispatch, navigate]);

    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate);
        setNextDate(endDate);
        setPage(1);
        setReload(e => !e);
    };

    useEffect(() => {
        ListData();
    }, [page, preDate, nextDate, maxFirstPage, reload]);

    const ListData = async () => {
        if (page === 1) setLoading(true);
        else setSpinner(true);

        await axios.get(process.env.REACT_APP_API + "/api/sugi", {
            withCredentials: true,
            params: {
                page: page,
                limit: maxFirstPage,
                startDate: preDate,
                endDate: nextDate,
            }
        }).then((response) => {
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                if (page === 1) {
                    setListData(tmp?.data?.sugi ?? []);
                } else {
                    setListData((prev) => [...prev, ...tmp?.data?.sugi ?? []]);
                }
                setAmount([Number(tmp?.data?.summary?.total_amount), Number(tmp?.data?.summary?.cancel_amount)]);
                setTotalPage(tmp?.data?.pagination?.total ?? 0);
            } else if (tmp?.code === 9999) {
                // 세션 만료 또는 인증 실패
                localStorage.setItem('v2_paylist_debug', JSON.stringify({
                    step: 'API 응답 9999 - 세션 만료',
                    timestamp: new Date().toISOString(),
                    code: tmp?.code
                }));
                localStorage.removeItem("userId");
                navigate('/', { replace: true });
            }
            setLoading(false);
            setSpinner(false);
        }).catch(error => {
            // 디버깅 정보 저장
            localStorage.setItem('v2_paylist_debug', JSON.stringify({
                step: 'API 호출 에러',
                timestamp: new Date().toISOString(),
                errorStatus: error.response?.status,
                errorMessage: error.message
            }));

            // 네트워크 에러나 인증 에러 시 로그인 페이지로
            if (error.response?.status === 401 || error.response?.status === 403) {
                localStorage.removeItem("userId");
                navigate('/', { replace: true });
            }
            // 다른 에러는 리다이렉트하지 않고 계속 진행
            setLoading(false);
            setSpinner(false);
        });
    };

    // 컬럼별 필터링 함수
    const filterDataByColumns = (data) => {
        if (!data || data.length === 0) return data;
        
        return data.filter((item) => {
            // 거래일 필터
            if (columnFilters.trxDate && !formatDateTime(item.trx_date)?.includes(columnFilters.trxDate)) {
                return false;
            }
            // 금액 필터
            if (columnFilters.amt && !changeNum(Number(item.amt))?.toString().includes(columnFilters.amt)) {
                return false;
            }
            // 카드번호 필터
            if (columnFilters.cardNum && !item.card_num?.toString().includes(columnFilters.cardNum)) {
                return false;
            }
            return true;
        });
    };

    const tableHeaderData = [
        {
            "no": 13,
            "text": (
                <div style={{ padding: "4px" }}>
                    <input
                        type="text"
                        placeholder="전표"
                        disabled
                        className="column-filter-input"
                        style={{
                            width: "100%",
                            height: "24px",
                            padding: "0 4px",
                            fontSize: "11px"
                        }}
                    />
                </div>
            ),
            "width": "40px",
            "textAlign": "center"
        },
        {
            "no": 2,
            "text": (
                <div style={{ padding: "4px" }}>
                    <input
                        type="text"
                        placeholder="거래일"
                        value={columnFilters.trxDate}
                        onChange={(e) => setColumnFilters({...columnFilters, trxDate: e.target.value})}
                        onClick={(e) => e.stopPropagation()}
                        className="column-filter-input"
                        style={{
                            width: "100%",
                            height: "24px",
                            padding: "0 4px",
                            fontSize: "11px"
                        }}
                    />
                </div>
            ),
            "width": "120px",
            "textAlign": "center"
        },
        {
            "no": 4,
            "text": (
                <div style={{ padding: "4px" }}>
                    <input
                        type="text"
                        placeholder="거래금액"
                        value={columnFilters.amt}
                        onChange={(e) => setColumnFilters({...columnFilters, amt: e.target.value})}
                        onClick={(e) => e.stopPropagation()}
                        className="column-filter-input"
                        style={{
                            width: "100%",
                            height: "24px",
                            padding: "0 4px",
                            fontSize: "11px"
                        }}
                    />
                </div>
            ),
            "width": "120px",
            "textAlign": "right"
        },
        {
            "no": 8,
            "text": (
                <div style={{ padding: "4px" }}>
                    <input
                        type="text"
                        placeholder="카드번호"
                        value={columnFilters.cardNum}
                        onChange={(e) => setColumnFilters({...columnFilters, cardNum: e.target.value})}
                        onClick={(e) => e.stopPropagation()}
                        className="column-filter-input"
                        style={{
                            width: "100%",
                            height: "24px",
                            padding: "0 4px",
                            fontSize: "11px"
                        }}
                    />
                </div>
            ),
            "width": "150px",
            "textAlign": "center"
        },
        {
            "no": 6,
            "text": "",
            "width": "auto",
            "textAlign": "left",
            "skeleton": true
        },
    ];

    useEffect(() => {
        let tableBodyData = [];
        let filteredData = filterDataByColumns(listData);
        
        if (filteredData) {
            for (let i = 0; i < filteredData.length; i++) {
                let data = filteredData[i];
                let trxDateOnly = data.trx_date?.slice(0, 10).replace(/-/g, '');
                let pre = preDate.replace(/\//g, '');
                let next = nextDate.replace(/\//g, '');

                if (Number(pre) <= Number(trxDateOnly) && Number(trxDateOnly) <= Number(next)) {
                    tableBodyData.push([
                        {
                            "no": 13,
                            "text": (
                                <div className='pointer list-text-center'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: "#0a6e0a" }}>
                                        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                                        <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                                    </svg>
                                </div>
                            ),
                            "width": "40px",
                            "textAlign": "center"
                        },
                        { "no": 2, "text": formatDateTime(data.trx_date), "width": "120px", "textAlign": "center" },
                        { "no": 4, "text": changeNum(Number(data.amt)), "width": "120px", "textAlign": "right" },
                        { "no": 8, "text": data.card_num, "width": "150px", "textAlign": "center" },
                        {
                            "no": 6,
                            "text": "",
                            "width": "auto",
                            "textAlign": "left",
                            "skeleton": true
                        },
                    ]);
                }
            }
            setListState(e => !e);
            setCombineData(tableBodyData);
        }
    }, [listData, reload, columnFilters, preDate, nextDate]);

    useEffect(() => {
        if (combineData.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && totalPage >= page * maxFirstPage) {
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [combineData, totalPage, page, maxFirstPage]);

    const excelBtn = () => {
        // TODO: 엑셀 다운로드 기능 구현
    };

    // 빠른 필터 버튼
    const quickFilters = [
        { label: "오늘", value: "", date: "today" },
        { label: "어제", value: "", date: "yesterday" },
        { label: "최근 7일", value: "", date: "7days" },
        { label: "최근 30일", value: "", date: "30days" },
        { label: "이번 달", value: "", date: "thisMonth" },
    ];

    const applyQuickFilter = (filter, index) => {
        // 같은 필터를 다시 클릭하면 해제
        if (activeQuickFilter === index) {
            setActiveQuickFilter(null);
            const today = dayjs();
            setPreDate(today.startOf('month').format('YYYY/MM/DD'));
            setNextDate(today.endOf('month').format('YYYY/MM/DD'));
            setDateRange(today.startOf('month').format('YYYY/MM/DD'), today.endOf('month').format('YYYY/MM/DD'));
        } else {
            setActiveQuickFilter(index);
            const today = dayjs();
            let startDate, endDate;

            if (filter.date === "today") {
                startDate = today.format('YYYY/MM/DD');
                endDate = today.format('YYYY/MM/DD');
            } else if (filter.date === "yesterday") {
                const yesterday = today.subtract(1, 'day');
                startDate = yesterday.format('YYYY/MM/DD');
                endDate = yesterday.format('YYYY/MM/DD');
            } else if (filter.date === "7days") {
                startDate = today.subtract(7, 'day').format('YYYY/MM/DD');
                endDate = today.format('YYYY/MM/DD');
            } else if (filter.date === "30days") {
                startDate = today.subtract(30, 'day').format('YYYY/MM/DD');
                endDate = today.format('YYYY/MM/DD');
            } else if (filter.date === "thisMonth") {
                startDate = today.startOf('month').format('YYYY/MM/DD');
                endDate = today.endOf('month').format('YYYY/MM/DD');
            }

            setDateRange(startDate, endDate);
        }
    };

    return (
        <Layout>
            <style>{`
                .column-filter-input {
                    background: #f5f5f5 !important;
                    border: 1px solid #ccc !important;
                }
                .column-filter-input:focus {
                    background: white !important;
                    border: 1px solid #999 !important;
                    outline: none !important;
                }
                .column-filter-input::placeholder {
                    color: #666 !important;
                    font-weight: 500 !important;
                    opacity: 1 !important;
                }
                .column-filter-input::-webkit-input-placeholder {
                    color: #666 !important;
                    font-weight: 500 !important;
                    opacity: 1 !important;
                }
                .column-filter-input::-moz-placeholder {
                    color: #666 !important;
                    font-weight: 500 !important;
                    opacity: 1 !important;
                }
                .column-filter-input:-ms-input-placeholder {
                    color: #666 !important;
                    font-weight: 500 !important;
                    opacity: 1 !important;
                }
            `}</style>
            {loading ? <LoadingModal /> : ""}
            <MessageModal message={""} />
            
            <div style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                height: '100%', 
                overflow: 'hidden',
                padding: '16px',
                gap: '12px'
            }}>
                {/* 빠른 필터 영역 */}
                <div style={{ 
                    background: "#f9fafb", 
                    border: "1px solid #d1d5db", 
                    padding: "12px",
                    flexShrink: 0
                }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                        <span style={{ fontSize: "12px", color: "#666", fontWeight: "500" }}>빠른 필터:</span>
                        {quickFilters.map((filter, idx) => (
                            <button
                                key={idx}
                                style={{
                                    padding: "6px 12px",
                                    fontSize: "12px",
                                    background: activeQuickFilter === idx ? "#3b82f6" : "white",
                                    border: "1px solid #d1d5db",
                                    cursor: "pointer",
                                    color: activeQuickFilter === idx ? "white" : "#333"
                                }}
                                onClick={() => applyQuickFilter(filter, idx)}
                                onMouseOver={(e) => {
                                    if (activeQuickFilter !== idx) {
                                        e.target.style.background = "#f0f0f0";
                                    }
                                }}
                                onMouseOut={(e) => {
                                    if (activeQuickFilter !== idx) {
                                        e.target.style.background = "white";
                                    }
                                }}
                            >
                                {filter.label}
                            </button>
                        ))}
                        <button
                            style={{
                                padding: "6px 12px",
                                fontSize: "12px",
                                background: "white",
                                border: "1px solid #d1d5db",
                                cursor: "pointer",
                                color: "#333"
                            }}
                            onClick={() => {
                                setActiveQuickFilter(null);
                                const today = dayjs();
                                setPreDate(today.startOf('month').format('YYYY/MM/DD'));
                                setNextDate(today.endOf('month').format('YYYY/MM/DD'));
                                setDateRange(today.startOf('month').format('YYYY/MM/DD'), today.endOf('month').format('YYYY/MM/DD'));
                            }}
                            onMouseOver={(e) => e.target.style.background = "#f0f0f0"}
                            onMouseOut={(e) => e.target.style.background = "white"}
                        >
                            초기화
                        </button>
                    </div>
                </div>

                {/* 통계 요약 및 테이블 영역 */}
                <div style={{ 
                    background: "white", 
                    border: "1px solid #d1d5db", 
                    display: "flex", 
                    flexDirection: "column", 
                    overflow: "hidden",
                    flex: 1,
                    minHeight: 0
                }}>
                    {/* 통계 요약 */}
                    <div style={{ 
                        display: "flex", 
                        justifyContent: "space-between", 
                        alignItems: "center", 
                        padding: "8px 12px", 
                        background: "#f5f5f5", 
                        borderBottom: "1px solid #d1d5db", 
                        fontSize: "12px",
                        flexShrink: 0,
                        flexWrap: "wrap",
                        gap: "12px"
                    }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <span style={{ color: "#666" }}>총 건수:</span>
                                <span style={{ fontWeight: "bold", color: "#333" }}>{changeNum(totalPage)}건</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <span style={{ color: "#666" }}>매출 합계:</span>
                                <span style={{ fontWeight: "bold", color: "#333" }}>{changeNum(Number(amount[0]) + Number(amount[1]) * -1)}원</span>
                            </div>
                        </div>
                        <button
                            onClick={excelBtn}
                            style={{
                                padding: "6px 12px",
                                fontSize: "12px",
                                background: "white",
                                border: "1px solid #999",
                                cursor: "pointer",
                                color: "#333"
                            }}
                            onMouseOver={(e) => e.target.style.background = "#f0f0f0"}
                            onMouseOut={(e) => e.target.style.background = "white"}
                        >
                            엑셀 다운로드
                        </button>
                    </div>

                    {/* 테이블 영역 */}
                    <div style={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={totalPage ?? 0}
                            filter_tableBodyData={combineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            listType={true}
                            listState={listState}
                            observerRef={observerRef}
                            nonePage={false}
                            scrollState={true}
                            height={"100%"}
                            spinner={spinner}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default PaylistV2;
